module.exports = __webpack_public_path__ + "static/media/pepoleActive.3e2ead79.png";